// Split-payment ledger rows (RPD-17338), sideloaded under payments via `include: 'charges'`.
// Every attribute is read-only on the API. Declaring the datetimes as `date` is what makes the
// client hand components a Date — without this entry `created_at` arrives as an ISO string and
// date-fns `format` throws "Invalid time value".
export default {
  fields: {
    payment_id: {
      readOnly: true,
    },
    amount: {
      readOnly: true,
    },
    status: {
      readOnly: true,
    },
    transaction_id: {
      readOnly: true,
    },
    default_for_overages: {
      readOnly: true,
    },
    failure_reason: {
      readOnly: true,
    },
    payment_method_token: {
      readOnly: true,
    },
    card_brand: {
      readOnly: true,
    },
    card_last4: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    },
  },
  relationships: {
    payment: {
      type: 'payments',
    },
  },
}
